<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="ui-module-card ui-module-fade-in-up nuevos-ingresos-shell" flat>
          <v-card-text class="pa-0">
            <v-container fluid>
              <v-row justify="end" align="center" class="px-4 pt-4">
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="buscaAspirante"
                    class="ui-form-field"
                    color="secondary"
                    background-color="transparent"
                    rounded
                    filled
                    placeholder="Buscar por nombre"
                    append-icon="mdi-magnify"
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col cols="auto">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <IconButton
                          class="ui-module-icon-action"
                          variant="secondary"
                          icon="mdi-download"
                          @click="downloadAspirantesCsv"
                        />
                      </span>
                    </template>
                    <span>Descargar CSV</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-data-table
                    class="transparent ui-module-table"
                    :headers="headers"
                    :items="aspirantes"
                    :search="buscaAspirante"
                    calculate-widths
                    :items-per-page="15"
                    :footer-props="{
                      'items-per-page-options': [10, 15, 25, 50, 100],
                    }"
                  >
                    <template v-slot:[`item.nombreCompleto`]="{ item }">
                      <span class="text-body-2">{{ getFullName(item) }}</span>
                    </template>
                    <template v-slot:[`item.fechaNacimiento`]="{ item }">
                      <span class="text-body-2">{{ formatDate(item.fechaNacimiento) }}</span>
                    </template>
                    <template v-slot:[`item.fechaRegistro`]="{ item }">
                      <span class="text-body-2">{{ formatDate(item.fechaRegistro) }}</span>
                    </template>
                    <template v-slot:[`item.activo`]="{ item }">
                      <v-chip small :color="item.activo ? 'success' : 'error'">
                        {{ item.activo ? 'Activo' : 'Inactivo' }}
                      </v-chip>
                    </template>
                    <template v-slot:[`item.opciones`]="{ item }">
                      <span class="d-flex align-center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                              <IconButton
                                class="ui-module-icon-action"
                                variant="secondary"
                                icon="mdi-card-account-details-outline"
                                :to="{
                                  path: '/desarrollo_profesional/documentos_personal/' + item.id_personal,
                                  params: { id: item.id_personal },
                                }"
                              />
                            </span>
                          </template>
                          <span>Ver expediente</span>
                        </v-tooltip>
                      </span>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import IconButton from '@/components/base/IconButton.vue'
import downloadCsv from '@/utils/downloadCsv'

export default {
  components: {
    IconButton,
  },

  data() {
    return {
      headers: [
        { text: 'Nombre completo', value: 'nombreCompleto', width: '300px' },
        { text: 'CURP', value: 'curp', width: '150px' },
        { text: 'CUIP', value: 'CUIP', width: '150px' },
        { text: 'RFC', value: 'rfc', width: '150px' },
        { text: 'Fecha nacimiento', value: 'fechaNacimiento', width: '100px' },
        { text: 'Fecha registro', value: 'fechaRegistro', width: '100px' },
        { text: 'Credencial', value: 'numeroCredencial', width: '100px' },
        { text: 'Estatus', value: 'activo', width: '100px', sortable: false },
        { text: 'Opciones', value: 'opciones', align: 'left', sortable: false },
      ],
      buscaAspirante: '',
      pageNumber: 1,
      rowsOfPage: 100,
    }
  },

  async mounted() {
    await this.fetchAspirantesConvertidosPolicias({
      pageNumber: this.pageNumber,
      rowsOfPage: this.rowsOfPage,
    })
  },

  computed: {
    ...mapGetters('aspirantes', {
      aspirantes: 'getAspirantesConvertidosPolicias',
    }),
    filteredAspirantes() {
      const term = (this.buscaAspirante || '').trim().toLowerCase()
      if (!term) return this.aspirantes || []
      return (this.aspirantes || []).filter((a) => this.getFullName(a).toLowerCase().includes(term))
    },
  },

  methods: {
    ...mapActions('aspirantes', ['fetchAspirantesConvertidosPolicias']),

    getFullName(aspirante) {
      return [
        aspirante.nombre?.trim(),
        aspirante.segundoNombre?.trim(),
        aspirante.apaterno?.trim(),
        aspirante.amaterno?.trim(),
      ]
        .filter(Boolean)
        .join(' ')
    },

    formatDate(date) {
      if (!date) return ''
      const options = { year: 'numeric', month: '2-digit', day: '2-digit' }
      return new Date(date).toLocaleDateString('es-MX', options)
    },

    downloadAspirantesCsv() {
      const rows = (this.filteredAspirantes || []).map((item) => ({
        'Nombre completo': this.getFullName(item),
        CURP: item.curp || '',
        CUIP: item.CUIP || '',
        RFC: item.rfc || '',
        'Fecha nacimiento': this.formatDate(item.fechaNacimiento),
        'Fecha registro': this.formatDate(item.fechaRegistro),
        Credencial: item.numeroCredencial || '',
        Estatus: item.activo ? 'Activo' : 'Inactivo',
      }))

      downloadCsv(rows, { filename: 'nuevos-ingresos' })
    },
  },
}
</script>

<style scoped>
::v-deep .ui-form-field .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.35) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.22) !important;
  border-radius: 12px !important;
  box-shadow: none !important;
  transition: all 0.25s ease !important;
}

::v-deep .ui-form-field .v-input__control > .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.38) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control > .v-input__slot {
  background: rgba(16, 16, 30, 0.48) !important;
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.12) !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-label,
::v-deep .ui-form-field .v-icon {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.68) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field.v-input--is-focused .v-icon {
  color: var(--v-secondary-base) !important;
}

/* Tooltips con colores dinámicos */
::v-deep .v-tooltip__content {
  background: rgba(16, 16, 30, 0.96) !important;
  color: #e0e0e0 !important;
  font-weight: 600;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.3);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.2);
}

/* Botones con efectos modernos */
::v-deep .v-btn {
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
}

::v-deep .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.6) !important;
}

::v-deep .v-btn:active {
  transform: translateY(0);
}

::v-deep .v-btn.v-btn--icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn.v-btn--icon:hover {
  transform: scale(1.2) rotate(5deg);
}

/* Loading state */
::v-deep .v-data-table__progress {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.1) !important;
}

::v-deep .v-data-table__progress .v-progress-linear__determinate {
  background: var(--v-secondary-base) !important;
}

::v-deep .v-progress-linear__indeterminate .v-progress-linear__indeterminate--active .long {
  background: var(--v-secondary-base) !important;
}

::v-deep .v-progress-linear__indeterminate .v-progress-linear__indeterminate--active .short {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.7) !important;
}

/* Empty state */
::v-deep .v-data-table__empty-wrapper {
  color: rgba(255, 255, 255, 0.6) !important;
  font-style: italic;
}

/* Footer de tabla */
::v-deep .v-data-footer {
  border-top: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.2) !important;
  background: transparent !important;
}

::v-deep .v-data-footer__select .v-select__selection {
  color: rgba(255, 255, 255, 0.9) !important;
}

::v-deep .v-data-footer__pagination {
  color: rgba(255, 255, 255, 0.9) !important;
}

/* Iconos de paginación */
::v-deep .v-data-footer .v-btn--icon {
  color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.8) !important;
}

::v-deep .v-data-footer .v-btn--icon:hover {
  color: var(--v-secondary-base) !important;
}

/* Scrollbar personalizado */
::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4);
  border-radius: 4px;
  transition: background 0.3s ease;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.6);
}

/* Card loading overlay */
::v-deep .v-card__progress {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.1) !important;
}

::v-deep .v-card__progress .v-progress-linear__determinate {
  background: var(--v-secondary-base) !important;
}

.nuevos-ingresos-shell {
  min-height: calc(100vh - 64px);
  min-height: calc(100dvh - 64px);
}

::v-deep .nuevos-ingresos-shell.v-card {
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

::v-deep .nuevos-ingresos-shell.v-card:hover {
  transform: none !important;
  box-shadow: none !important;
}
</style>
